var exports = {
  "success": "PurchaseHistoryStatus.module__success___ZS1WQn",
  "pending": "PurchaseHistoryStatus.module__pending___ZS1WQn",
  "muted": "PurchaseHistoryStatus.module__muted___ZS1WQn",
  "neutral": "PurchaseHistoryStatus.module__neutral___ZS1WQn",
  "danger": "PurchaseHistoryStatus.module__danger___ZS1WQn",
};

__webpack_require__.r(module.exports = exports);
